import ApartmentDeleteConfirmModal from './ApartmentDeleteConfirmModal';

export default ApartmentDeleteConfirmModal;
